// extracted by mini-css-extract-plugin
module.exports = {"upload":"upload--2TI48","uploadText":"uploadText--19VAw","uploadImg":"uploadImg--28fjZ","upload_text":"upload_text--26229"};